import React, { useEffect, useState, useCallback } from "react";
import IntlMessages from "util/IntlMessages";
import {
  Modal,
  Card,
  Table,
  Row,
  Col,
  Button,
  Tooltip,
  Input,
  Form,
  Spin,
  List,
  Select,
  Upload
} from "antd";

import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  useGetSalesRequestDataQuery,
  useGetSalesMappedDataQuery,
  useEditSalesRequestMutation,
  useLazyDownloadPOApprovalRequestsDocumentQuery,
  useGetRoyaltyPartnerListQuery,
  useGetProductListQuery,
  useGetCountryListQuery,
} from "../../../appRedux/api/royaltySalesApi";
import {
  EditOutlined,
  EyeTwoTone,
  InfoCircleTwoTone,
  CopyOutlined,
  MessageTwoTone,
  DownloadOutlined,
  CheckCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { getRole, getUserInfo, getIsApprover } from "../../../helpers";
import moment from "moment";
import { royaltyApprovalStatus } from "../../../constants";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import "./needs-clarification.css";
import "./style.css";
import ClarificationChat from "./clarification_chat_popup";
import classNames from "classnames";
import * as FileSaver from "file-saver";
import RoyaltySalesDrawer from "../../../components/RoyaltySalesDrawer";
import CustomPagination from "../../../components/CustomPagination";
import PartnerRaiseEditApprovalRequestDrawer from "../../../components/PartnerRaiseEditApprovalRequestDrawer";
import "../../../components/RoyaltySalesDrawer/style.css";
import LoadingBar from "../../../components/LoadingBar";
import infoIcon from "assets/images/icons/info.svg";
import eyeIcon from "assets/images/icons/visibility.svg";
import notificationBellIcon from "assets/images/icons/notification.svg";
import deleteTempIcon from "assets/images/icons/delete.svg";
import editIcon from "assets/images/icons/Edit.svg";
const { TextArea } = Input;

const CustomFilterDropdown = ({
  options,
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
  placeholder = "Search..."
}) => (
  <div style={{ padding: 8, width: 280 }}>
    <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
      <Select
        mode="multiple"
        placeholder={placeholder}
        value={selectedKeys}
        onChange={setSelectedKeys}
        showSearch
        style={{
          width: '100%',
          minHeight: 20,
          marginBottom: 0,
          display: 'block'
        }}
        filterOption={(input, option) => {
          const label = option?.label ?? option?.children ?? option?.value ?? "";
          return String(label).toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }}
        maxTagCount="responsive"
        allowClear={false}
        dropdownRender={menu => (
          <>
            {menu}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 8,
              padding: '0 8px'
            }}>
              <Button
                size="small"
                onClick={() => {
                  clearFilters && clearFilters();
                  confirm && confirm();
                }}
                style={{ flex: 1 }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                size="small"
                onClick={() => confirm && confirm()}
                style={{ flex: 1 }}
              >
                Apply
              </Button>
            </div>
          </>
        )}
      >
        {options.map(option => (
          <Select.Option key={option} value={option}>
            {option}
          </Select.Option>
        ))}
      </Select>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
      <Button
        size="small"
        style={{ flex: 1 }}
        onClick={() => {
          clearFilters && clearFilters();
          confirm && confirm();
        }}
      >
        Reset
      </Button>
      <Button
        type="primary"
        size="small"
        style={{ flex: 1 }}
        onClick={() => confirm && confirm()}
      >
        Apply
      </Button>
    </div>
  </div>
);

const PartnerRoyaltySalesApproval = (props) => {
  const [isUserAdmin, setIsUserAdmin] = useState(false);
  const [isUserPartner, setIsUserPartner] = useState(false);
  const [isUserStaff, setIsUserStaff] = useState(false);
  const [productFilterOptions, setProductFilterOptions] = useState([]);
  const [countryFilterOptions, setCountryFilterOptions] = useState([]);
  const [partnerFilterOptions, setPartnerFilterOptions] = useState([]);
  const [isAdminApprover, setIsAdminApprover] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [chatConversation, setChatConversation] = useState([]);
  const [isChatModalVisible, setIsChatModalVisible] = useState(false);
  const [messageInput, setMessageInput] = useState("");
  const [requestSatus, setRequestStatus] = useState();
  const [requestObj, setRequestObj] = useState({
    limit: 10,
    offset: 0,
    current: 1,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRequestParams, setSelectedRequestParams] = useState(null);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({});
  const [balanceQuantity, setBalanceQuantity] = useState(0);
  const [currentRequestTotalQuantity, setCurrentRequestTotalQuantity] = useState(0);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [selectedViewItem, setSelectedViewItem] = useState(null);
  const [isViewItemLoading, setIsViewItemLoading] = useState(false);
  const [isRaiseEditDrawerVisible, setIsRaiseEditDrawerVisible] = useState(false);
  const [drawerMode, setDrawerMode] = useState('add'); // 'add' or 'edit'
  const [selectedRequestForEdit, setSelectedRequestForEdit] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [form] = Form.useForm();

  const isDiagnosticAdmin = getRole() === "DIAGNOSTIC_ADMIN" || getRole() === "DIAGNOSTIC_REVIEWER";

  // Get user role and details at component mount only
  useEffect(() => {
    setUserDetails(getUserInfo());
    setIsAdminApprover(getIsApprover());
    setIsUserAdmin(getRole() === "ADMIN");
    setIsUserPartner(getRole() === "PARTNER");
    setIsUserStaff(getRole() === "STAFF");
  }, []);

  // RTK Query hooks - explicitly define query params to prevent unnecessary refetches
  const { data: salesrequestdata = {}, isLoading: isRoyaltySalesLoading, isFetching: isRoyaltySalesFetching, refetch: refetchSalesData } =
    useGetSalesRequestDataQuery(
      {
        limit: requestObj.limit,
        offset: requestObj.offset,
        ...filter,
      },
      {
        refetchOnMountOrArgChange: true,
      },
    );

  // Set filter options from API response data
  useEffect(() => {
    if (salesrequestdata && salesrequestdata.countries) {
      setCountryFilterOptions(salesrequestdata.countries);
    }
    if (salesrequestdata && salesrequestdata.products) {
      setProductFilterOptions(salesrequestdata.products);
    }
    if (salesrequestdata && salesrequestdata.partner_names) {
      setPartnerFilterOptions(salesrequestdata.partner_names);
    }
  }, [salesrequestdata]);

  const { data: salesmappeddata = [], isLoading: isRoyaltySalesMappedLoading } =
    useGetSalesMappedDataQuery(selectedRequestParams, {
      skip: !selectedRequestParams,
    });
  
  // Calculate balance quantity when sales data or total quantity changes
  useEffect(() => {
    if (salesmappeddata && salesmappeddata.length > 0) {
      // Sum all sales quantities
      const totalSalesQuantity = salesmappeddata.reduce((sum, sale) => {
        return sum + parseFloat(sale.quantity || 0);
      }, 0);
      
      // Calculate balance using state
      const balance = currentRequestTotalQuantity - totalSalesQuantity;
      setBalanceQuantity(balance);
    } else {
      // If no sales data, balance equals total quantity
      setBalanceQuantity(currentRequestTotalQuantity);
    }
  }, [salesmappeddata, currentRequestTotalQuantity]);

  const [editSalesRequest] = useEditSalesRequestMutation();
  const [downloadPODocument, { isLoading: isDownloading }] =
    useLazyDownloadPOApprovalRequestsDocumentQuery();

  // Show loading either during initial load or when fetching during pagination
  const isTableLoading = isRoyaltySalesLoading || isRoyaltySalesFetching;

  // Set data from API response, with dependency only on the response
  useEffect(() => {
    if (salesrequestdata) {
      let newData;
      let newCount;

      if (Array.isArray(salesrequestdata)) {
        // Handle array response (old format)
        newData = salesrequestdata;
        newCount = salesrequestdata.length;
      } else if (salesrequestdata.results && Array.isArray(salesrequestdata.results)) {
        // Handle paginated response with results property
        newData = salesrequestdata.results;
        newCount = salesrequestdata.count || salesrequestdata.results.length;
      } else {
        // Default case, don't update
        return;
      }

      // Always update data when API response changes (filters, pagination, etc.)
      setData(newData);
      setTotalCount(newCount);
    }
  }, [salesrequestdata]);

  const columnDefs = [
    {
      headerName: "Company Name",
      field: "partner_id.company_name",
      width: 150,
    },
    {
      headerName: "Product Name",
      field: "product_id.product_name",
      width: 250,
    },
    {
      headerName: "Country Name",
      field: "country_id.country_name",
      width: 150,
    },
    { headerName: "Quarter", field: "quarter_id.quarter_name", width: 150 },
    {
      headerName: "Quantity",
      field: "quantity",
      width: 150,
      valueFormatter: (params) => formatDecimal(params.value, 2),
    },
    {
      headerName: "Pack Size",
      field: "pack_size",
      width: 150,
      valueFormatter: (params) => formatDecimal(params.value, 2),
    },
  ];

  function formatDecimal(value, decimalPlaces) {
    return value ? parseFloat(value).toFixed(decimalPlaces) : "0.00";
  }

  const handleClarificationClick = (chatMessages) => {
    setChatConversation(chatMessages);
    setIsChatModalVisible(true);
  };

  const handleRequestClick = (requestId, mappingId) => {
    setSelectedRequestParams(requestId);
    setSelectedRequest(mappingId);
    setIsModalVisible(true);
  
  // Find the current request data to get total quantity
  const currentRequest = data.find(item => item.request_id === requestId);
    if (currentRequest) {
      setCurrentRequestTotalQuantity(parseFloat(currentRequest.quantity || 0));
    }
  };

  const gridOptions = {
    // ag-Grid options
  };

  const handleMessageChange = (e) => {
    setMessageInput(e.target.value);
  };

  const handleSendMessage = (item) => {
    if (messageInput.trim() !== "") {
      const newMessage = {
        message: messageInput.trim(),
        is_partner: isUserPartner,
      };

      const formData = new FormData();
      formData.append("status", "NEEDS CLARIFICATION");
      formData.append("message", newMessage.message);

      editSalesRequest({
        id: item,
        data: formData,
        status: "Message Sent",
      });

      const updatedChatConversation = [...chatConversation, newMessage];
      setMessageInput("");
      setChatConversation(updatedChatConversation);
    }
  };

  const handleCloseModal = () => {
  setIsModalVisible(false);
  setSelectedRequestParams(null);
  setBalanceQuantity(0);
  setCurrentRequestTotalQuantity(0);
  };

  const navigateToAddSalesData = () => {
    navigate("/partner/royalty-sales-approvals/raise-request");
  };

  const navigateToContent = (item) => {
    navigate({
      pathname: `/partner/royalty-sales-approvals/edit-request/${item.request_id}`,
      // search: queryParams.toString(),
    });
  };

  const navigateToViewContent = (item) => {
    showDrawer(item);
  };

  // Replace navigateToAddSalesData with:
  const showRaiseRequestDrawer = () => {
    setDrawerMode('add');
    setSelectedRequestForEdit(null);
    setIsRaiseEditDrawerVisible(true);
  };

  // Replace navigateToContent with:
  const showEditRequestDrawer = (item) => {
    setDrawerMode('edit');
    setSelectedRequestForEdit(item);
    setIsRaiseEditDrawerVisible(true);
  };

  // Update handleTableChange to handle pagination
  const handleTableChange = useCallback(
    (pagination, filters, sorter) => {
      // Handle pagination changes
      if (pagination) {
        setRequestObj(prev => {
          // Only update if values actually changed to prevent unnecessary rerenders
          if (prev.current !== pagination.current || prev.limit !== pagination.pageSize) {
            return {
              limit: pagination.pageSize,
              offset: (pagination.current - 1) * pagination.pageSize || 0,
              current: pagination.current,
            };
          }
          return prev;
        });
      }

      // Build filter object for API call
      const apiFilters = {};

      // Handle filters
      if (filters) {
        // Map frontend filter keys to backend parameter names
        const keyMap = {
          partner_id: "partner_name",
          product_id: "product",
          country_id: "country_of_sale",
          status: "status", // Keep this as "status" for backend
          mapping_id: "request_id_type",
        };

        Object.keys(filters).forEach((key) => {
          if (filters[key] && filters[key].length > 0) {
            const backendKey = keyMap[key] || key;
            // For status filter, send the array of selected status values
            apiFilters[backendKey] = filters[key];
          }
        });
      }

      // Handle sorting - add ordering parameter
      if (sorter && sorter.field && sorter.order) {
        // Map frontend field names to backend field names for sorting
        const sortFieldMap = {
          "quantity": "quantity",
          "pack_size": "pack_size",
          "request_date": "request_date",
          "approval_date": "approval_date",
          "expected_date_of_sale": "expected_date_of_sale",
          "buyer_name_and_address": "buyer_name_and_address",
          "end_customer_and_address": "end_customer_and_address",
          "status": "status"
        };

        const backendField = sortFieldMap[sorter.field] || sorter.field;
        apiFilters.ordering = sorter.order === 'desc' ? `-${backendField}` : backendField;
      }

      // Check if filters or sorting actually changed
      const newFiltersString = JSON.stringify(apiFilters);
      const prevFiltersString = JSON.stringify(filter);

      if (newFiltersString !== prevFiltersString) {
        setFilter(apiFilters); // Store mapped filters for API

        // Update URL params for browser state
        const newQueryParams = new URLSearchParams();

        if (filters) {
          Object.keys(filters).forEach((key) => {
            if (filters[key] && filters[key].length > 0) {
              filters[key].forEach((value) => {
                if (value) newQueryParams.append(key, value);
              });
            }
          });
        }

        // Add sorting to URL params
        if (sorter && sorter.field && sorter.order) {
          newQueryParams.append('ordering', sorter.order === 'desc' ? `-${sorter.field}` : sorter.field);
        }

        const search = newQueryParams.toString()
          ? `?${newQueryParams.toString()}`
          : "";

        if (search !== location.search) {
          navigate({ search });
        }
      }
    },
    [navigate, location.search, filter]
  );

  const handleDownloadClick = async () => {
    let paramsObject = {};

    // Map to rename keys
    const keyMap = {
      partner_id: "partner_name",
      product_id: "product",
      country_id: "country_of_sales",
      status: "status",
      mapping_id: "request_id_type",
    };

    // Iterate through all entries
    for (const [key, value] of queryParams.entries()) {
      const newKey = keyMap[key] || key; // Replace the key if it's in the keyMap, otherwise keep it

      // Check if the key already exists
      if (paramsObject[newKey]) {
        // If it's not an array, convert it to an array
        if (!Array.isArray(paramsObject[newKey])) {
          paramsObject[newKey] = [paramsObject[newKey]];
        }
        // Add the new value to the array
        paramsObject[newKey].push(value);
      } else {
        if (value?.length > 0) {
          // If key doesn't exist, just assign the value
          paramsObject[newKey] = [value];
        } else {
          paramsObject[newKey] = null;
        }
      }
    }
    const payload = { ...requestObj, ...paramsObject };

    try {
      const result = await downloadPODocument(payload);
      if (result.data) {
        FileSaver.saveAs(result.data, "royalty-po-approval-requests.csv");
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  // Get filter values from URL for column configuration
  const getDefaultFilteredValue = (key) => {
    return queryParams.get(key) ? queryParams.getAll(key) : [];
  };

  const handleRejectionUpload = async (file, requestId, onSuccess, onError) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('request_id', requestId);
    formData.append('category', 'REJECTION');

    try {
      const response = await fetch('/api/royalty-sales/upload-rejection-doc', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) throw new Error('Upload failed');
      
      onSuccess();
      // Refresh data to show new document
      dispatch(getSalesRequestData()); 
    } catch (error) {
      onError(error);
    }
  };

  const columns = [
    ...(isUserAdmin || isUserStaff || isDiagnosticAdmin
      ? [
          {
            title: "Partner Name",
            dataIndex: ["partner_id", "company_name"],
            key: "partner_id",
            align: "center",
            width: "10%",
            fixed: 'top',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <CustomFilterDropdown
                options={partnerFilterOptions}
                selectedKeys={selectedKeys}
                setSelectedKeys={setSelectedKeys}
                confirm={confirm}
                clearFilters={clearFilters}
                placeholder="Search partners..."
                alignRight={true}
              />
            ),
            defaultFilteredValue: getDefaultFilteredValue("partner_id"),
            filterMultiple: true,
          },
        ]
      : []),
{
      title: "Product",
      dataIndex: ["product_id", "product_name"],
      key: "product_id",
      align: "center",
      width: "15%",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <CustomFilterDropdown
          options={productFilterOptions}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
          placeholder="Search products..."
          alignRight={true}
        />
      ),
      defaultFilteredValue: getDefaultFilteredValue("product_id"),
      filterMultiple: true,
    },
    {
      title: "Country Of Sale",
      dataIndex: ["country_id", "country_name"],
      key: "country_id",
      align: "center",
      width: "10%",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <CustomFilterDropdown
          options={countryFilterOptions}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
          placeholder="Search countries..."
        />
      ),
      defaultFilteredValue: getDefaultFilteredValue("country_id"),
      filterMultiple: true,
    },
    {
      title: "Request Date",
      dataIndex: "request_date",
      key: "request_date",
      align: "center",
      width: "10%",
      defaultSortOrder: "desc",
      sorter: true,
      render: (text, record) =>
        record.request_date
          ? moment(record.request_date).format("DD/MM/YYYY")
          : "-",
    },
    {
      title: "Approval Date",
      dataIndex: "approval_date",
      key: "approval_date",
      align: "center",
      width: "10%",
      sorter: true,
      render: (text, record) => {
        if (record.approval_date) {
          return moment(record.approval_date).format("DD/MM/YYYY");
        } else {
          return "-";
        }
      },
    },

    {
      title: "Expected Date Of Sales",
      dataIndex: "expected_date_of_sale",
      key: "expected_date_of_sale",
      align: "center",
      width: "10%",
      sorter: true,
      render: (text, record) =>
        record.expected_date_of_sale
          ? moment(record.expected_date_of_sale).format("DD/MM/YYYY")
          : "-",
    },
    {
      title: "Pack Size",
      dataIndex: "pack_size",
      key: "pack_size",
      align: "center",
      sorter: true,
      width: "8%",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      align: "center",
      sorter: true,
      width: "10%",
    },
    ...(isUserPartner || isUserStaff
      ? [
          {
            title: "Buyer Name and Address",
            dataIndex: ["buyer_name_and_address"],
            key: "buyer_name_and_address",
            align: "center",
            sorter: true,
            width: "15%",
          },
        ]
      : []),
    ...(isUserPartner || isUserStaff
      ? [
          {
            title: "End Customer and Address",
            dataIndex: ["end_customer_and_address"],
            key: "end_customer_and_address",
            align: "center",
            sorter: true,
            width: "15%",
          },
        ]
      : []),
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      width: "13%",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <CustomFilterDropdown
          options={royaltyApprovalStatus}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
          placeholder="Search status..."
        />
      ),
      defaultFilteredValue: getDefaultFilteredValue("status"),
      filterMultiple: true,
      render: (text, record) => (
        <Tooltip title={text !== "PENDING" ? record.comment : null}>
          <span
            style={{
              color:
                text === "APPROVED"
                  ? "limegreen"
                  : text === "REJECTED"
                    ? "red"
                    : text === "NEEDS CLARIFICATION" ||
                        text === "REVISIONS REQUIRED"
                      ? "orange"
                      : "black",
            }}
          >
            {text}
          </span>
          {text !== "PENDING" && text !== "NEEDS CLARIFICATION" && (
            <InfoCircleTwoTone className="ml-10" twoToneColor={["#718096", "#FFF"]} />
          )}
          {record.clarification && record.clarification.length !== 0 && (
            <Tooltip
              onClick={() => {
                handleClarificationClick(record.clarification);
                setRequestStatus(text === "NEEDS CLARIFICATION");
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                  paddingLeft: "5px",
                }}
              >
                <MessageTwoTone twoToneColor="#00AEEF" className="font-20" />
              </span>
            </Tooltip>
          )}
        </Tooltip>
      ),
    },
    {
      title: "Documents",
      dataIndex: "file",
      key: "file",
      align: "center",
      width: "11%",
      render: (files) =>
        files && Array.isArray(files) ? (
          <Tooltip style={{ textAlign: "left" }}>
            {files.filter((file) => file.category === 'PR/PO').map((file, index) => (
              <React.Fragment key={file.po_id || index}>
                <a
                  href={file.po_document}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  PO {index + 1}
                </a>
                <br />
              </React.Fragment>
            ))}
          </Tooltip>
        ) : null,
    },

    {
      title: "Request ID",
      dataIndex: "mapping_id",
      key: "mapping_id",
      align: "center",
      width: "14%",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <CustomFilterDropdown
          options={[
            "Sales Completed",
            "Partially Sales Completed", 
            "Pending Sales",
            "Rejected"
          ]}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
          placeholder="Search request status..."
        />
      ),
      defaultFilteredValue: getDefaultFilteredValue("mapping_id"),
      filterMultiple: true,
      render: (text, record, index) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Tooltip
            onClick={() =>
              handleRequestClick(record.request_id, record.mapping_id)
            }
          >
            <span
              style={{
                color:
                  record.status === "REJECTED"
                    ? "red"
                    : record.sales_data.length > 0 &&
                      record.sales_data.reduce((total, item) => total + parseInt(item.quantity), 0) === record.quantity
                    ? "limegreen"
                    : record.is_sales_completed ||
                      (
                        record.sales_data.length > 0 &&
                        record.quantity &&
                        record.sales_data.reduce((total, item) => total + parseInt(item.quantity), 0) < record.quantity &&
                        record.sales_data.reduce((total, item) => total + parseInt(item.quantity), 0) !== 0
                      )
                    ? "orange"
                    : "black"
              }}
            >
              <b>{text}</b>
            </span>
          </Tooltip>
          {record.is_sales_completed && (
            <Tooltip title={record.sales_completed_comment}>
              <CheckCircleOutlined
                style={{
                  color: 'green',
                  marginLeft: '5px',
                  fontSize: '16px'
                }}
              />
            </Tooltip>
          )}
        </div>
      ),
    },

    {
      title: "Action",
      key: "operation",
      align: "center",
      width: "7%",
      render: (item) => (
        <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center" }}>
          {isUserAdmin ? (
            <>
              <Tooltip title="View request">
                <img
                  className="icon"
                  style={{ cursor: "pointer" }}
                  src={eyeIcon}
                  onClick={() => showDrawer(item)}
                  id={"view-" + item.tracking_id}
                  alt="eye"
                />
              </Tooltip>
            </>
          ) : (
            <>
              <Button
                type="link"
                className="margin-0"
                onClick={() => showDrawer(item)}
                id={"view-" + item.request_id}
              >
                <Tooltip title="View request">
                  <img
                    className="icon"
                    style={{ cursor: "pointer" }}
                    src={eyeIcon}
                    alt="eye"
                  />
                </Tooltip>
              </Button>
              <Button
                type="link"
                className="margin-0"
                id={"upload-" + item.request_id}
                disabled={
                  item.status === "APPROVED" || item.status === "PENDING" || item.status === "REJECTED"
                }
                onClick={() => {
                  showEditRequestDrawer(item);
                }}
              >
                <Tooltip title="Edit">
                  <EditOutlined twoToneColor="#00AEEF" className="font-20" />
                </Tooltip>
              </Button>
            </>
          )}
        </div>
      ),
    },
  ];

  // Function to fetch single sales request data when viewing
  const fetchSalesRequestData = async (requestId) => {
    setIsViewItemLoading(true);
    try {
      const result = await fetch(`/api/royalty-sales/request/${requestId}`);
      const data = await result.json();
      setSelectedViewItem(data);
    } catch (error) {
      console.error("Error fetching request data:", error);
    } finally {
      setIsViewItemLoading(false);
    }
  };

  const showDrawer = (item) => {
    setSelectedViewItem(item);
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
    setSelectedViewItem(null);
  };

  return (
    <div className="royalty-sales-approval-page">
      <Row>
        <Col span={24}>
          <div
            className="gx-flex-row"
            style={{ justifyContent: "space-between" }}
          >
            <h1 className="title gx-mb-4">
              <IntlMessages id="sidebar.royalty-sales-approval-request" />
            </h1>
            <div>
              {isUserPartner && (
                <Button
                  type="primary"
                  id="raise-request"
                  onClick={showRaiseRequestDrawer}
                >
                  <CopyOutlined className="font-16" />
                  Raise Request
                </Button>
              )}
              <Tooltip title={<IntlMessages id="po-request.download" />}>
                <Button
                  id="po-request.download"
                  className="mr-0"
                  onClick={handleDownloadClick}
                  loading={isDownloading}
                >
                  <DownloadOutlined className="font-20" />
                </Button>
              </Tooltip>
            </div>
          </div>
        </Col>
        {isTableLoading ? (
            <LoadingBar loading={isTableLoading} />
          ) : (
        <Table
          className="gx-table-responsive mpp-list-table"
          columns={columns}
          dataSource={data}
          onChange={handleTableChange}
          bordered
          scroll={{ y: 'calc(100vh - 250px)', x: "100%" }}
          style={{ width: "100%" }}
          pagination={false}
          sticky={true}
        />
          )}

        {/* Custom Pagination */}
        <CustomPagination
          current={requestObj.current}
          total={totalCount}
          pageSize={requestObj.limit}
          onChange={(page, pageSize) => {
            setRequestObj(prev=>({
              ...prev,
              limit: pageSize,
              offset: (page - 1) * pageSize,
              current: page,
            }));
          }}
          showSizeChanger={true}
          pageSizeOptions={['10', '20', '50', '100']}
        />
      </Row>

      <Modal
        title={
          <div>
            <div style={{ fontWeight: 500, marginBottom: '4px' }}>Request ID: {selectedRequest}</div>
            <div style={{
              fontSize: '14px',
              fontWeight: 'normal'
            }}>
              Balance Quantity: {formatDecimal(balanceQuantity, 2)}
            </div>
          </div>
        }
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={false}
        width="50%"
        centered
      >
        
        {isRoyaltySalesMappedLoading ? (
          <LoadingBar loading={isRoyaltySalesMappedLoading}/>
        ) : (
          <div
            className="ag-theme-balham ag-scroll-bar-fix"
            style={{ height: "500px", width: "100%", margin: "auto" }}
          >
            <AgGridReact
              gridOptions={gridOptions}
              columnDefs={columnDefs}
              rowData={salesmappeddata}
              defaultColDef={{
                filter: true,
                sortable: true,
                width: 300,
                resizable: true,
              }}
              rowSelection={"multiple"}
              suppressRowClickSelection={true}
            />
          </div>
        )}
      </Modal>
      <Modal
        title="Clarification Chat"
        visible={isChatModalVisible}
        onCancel={() => setIsChatModalVisible(false)}
        footer={null}
      >
        <div style={{ maxHeight: 400, overflowY: "auto" }}>
          <List
            itemLayout="horizontal"
            dataSource={chatConversation}
            renderItem={(message) => (
              <List.Item
                className={classNames("chat-message", {
                  "chat-message-user": !message.is_partner,
                  "chat-message-partner": message.is_partner,
                })}
              >
                <List.Item.Meta
                  description={
                    <div
                      style={{
                        background: message.is_partner ? "#f6f6f6" : "#e6f7ff",
                      }}
                      className="chat-message-content"
                    >
                      {message.message}
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        </div>
        {requestSatus && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            <TextArea
              rows={3}
              value={messageInput}
              onChange={handleMessageChange}
              placeholder="Type your message..."
              autoFocus
              style={{ flex: 1, marginRight: 10 }}
            />
            <Button
              type="primary"
              onClick={() => {
                handleSendMessage(chatConversation[0].request_id);
              }}
            >
              Send
            </Button>
          </div>
        )}
      </Modal>
      
      {isViewItemLoading ? (
      <LoadingBar loading={isViewItemLoading} />
          ) : (
      <RoyaltySalesDrawer
        visible={isDrawerVisible}
        onClose={closeDrawer}
        requestData={selectedViewItem}
        isLoading={isViewItemLoading}
        refetchData={() => fetchSalesRequestData(selectedViewItem.request_id)}
      />
      )}
      <PartnerRaiseEditApprovalRequestDrawer
        visible={isRaiseEditDrawerVisible}
        onClose={() => setIsRaiseEditDrawerVisible(false)}
        editMode={drawerMode === 'edit'}
        requestId={selectedRequestForEdit?.request_id}
        onSuccess={() => refetchSalesData()}
      />
    </div>
  );
};

export default PartnerRoyaltySalesApproval;